export default __webpack_public_path__ + "static/media/Homebk.f5212937.jpg";